export var getCheckboxItems = function (stateKeys, options) {
    if (options === void 0) { options = {}; }
    var checkboxItems = stateKeys.map(function (stateKey) {
        var _a, _b, _c;
        var labelText = (_b = (_a = options.labelTextMap) === null || _a === void 0 ? void 0 : _a.get(stateKey)) !== null && _b !== void 0 ? _b : stateKey;
        var labelLink = (_c = options.labelLinkMap) === null || _c === void 0 ? void 0 : _c.get(stateKey);
        return {
            checkboxStateKey: stateKey,
            labelText: labelText,
            labelLink: labelLink
        };
    });
    return options.alphabetize === true
        ? checkboxItems.sort(function (_a, _b) {
            var labelTextA = _a.labelText;
            var labelTextB = _b.labelText;
            return labelTextA.localeCompare(labelTextB);
        })
        : checkboxItems;
};
